module.exports = __webpack_public_path__ + "img/unavailable.e283b7e0.svg";